import { Card } from "@/components/ui/card";

const reviews = [
  {
    quote: "Studying became faster and way more efficient",
    description:
      "I used to spend so much time going through lectures. Now everything is organized and easier to review. It really supports me throughout my academic journey.",
    name: "Heba Mousa",
    title: "Medical Student",
    avatar1: "/images/avatars/heba-mousa.jpg",
    avatar2: "/images/logos/king-abdulaziz.png",
  },
  {
    quote: "Now I understand concepts that confused me for years",
    description:
      "I failed chemistry twice. Shattara explained it differently and it finally clicked. Passed with an 87.",
    name: "Marcus Johnson",
    title: "College Student",
    avatar1: "/images/avatars/review-2a.jpg",
    avatar2: "/images/logos/stanford.png",
  },
  {
    quote: "An amazing way to revise and be sure we covered everything",
    description:
      "I really like all the tools Shattara offers—quizzes, summaries, flashcards, and more. It makes studying faster, more efficient, and keeps me confident that nothing is missed.",
    name: "Sara Saliba",
    title: "Medical Student",
    avatar1: "/images/avatars/sara-saliba.jpg",
    avatar2: "/images/logos/usj.png",
  },
  {
    quote: "The personalized learning paths were eye-opening",
    description: "Shattara AI has done an amazing job helping me prepare for exams, absolutely eye-opening!",
    name: "David Martinez",
    title: "University Student",
    avatar1: "/images/avatars/review-4a.jpg",
    avatar2: "/images/logos/oxford.png",
  },
];

export const Reviews = () => {
  // Duplicate reviews for seamless loop
  const duplicatedReviews = [...reviews, ...reviews, ...reviews];

  return (
    <section id="reviews" className="relative w-full py-20 px-4 md:px-10 bg-background overflow-hidden">
      <div className="container mx-auto max-w-[90rem]">
        {/* Header */}
        <div className="flex flex-col items-center justify-center mb-12">
          <h2 className="text-4xl md:text-6xl font-medium text-foreground leading-none text-center">
            Don't Take Our Word For It — Here's What <span className="text-primary">Students</span> Say
          </h2>
        </div>

        {/* Scrolling Reviews */}
        <div className="relative overflow-hidden py-4">
          <div
            className="flex items-stretch"
            style={{
              maskImage:
                "linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 17.5%, rgb(0, 0, 0) 82.5%, rgba(0, 0, 0, 0) 100%)",
            }}
          >
            <div className="flex gap-6 animate-marquee-horizontal" style={{ animationDuration: "60s" }}>
              {duplicatedReviews.map((review, index) => (
                <Card
                  key={index}
                  className="flex-shrink-0 w-96 p-10 rounded-xl bg-card border-border hover:shadow-lg transition-shadow cursor-pointer"
                >
                  <div className="flex flex-col gap-5 h-full">
                    {/* Quote */}
                    <h3 className="text-3xl font-medium text-foreground leading-tight">"{review.quote}"</h3>

                    {/* Description */}
                    <p className="text-base text-muted-foreground">{review.description}</p>

                    {/* Author Info */}
                    <div className="flex items-center gap-4 mt-auto">
                      {/* University Logo + Person Avatar */}
                      <div className="relative flex items-center h-12">
                        <img
                          src={review.avatar2}
                          alt="University"
                          className="w-12 h-12 rounded-full object-contain bg-background border-2 border-background p-1.5"
                        />
                        <img
                          src={review.avatar1}
                          alt="Student"
                          className="w-12 h-12 rounded-full object-cover border-2 border-background -ml-4"
                        />
                      </div>

                      {/* Name and Title */}
                      <div className="flex flex-col gap-0.5">
                        <p className="text-foreground font-medium">{review.name}</p>
                        <p className="text-primary text-sm">{review.title}</p>
                      </div>
                    </div>
                  </div>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
